const config = {
    // IMAGE_BASE_PATH: "https://admin.banglaconstruction.store/public/",
    IMAGE_BASE_PATH: "https://nzbd.websolutionfirm.com/public/",
    // IMAGE_BASE_PATH: "http://127.0.0.1:8000/",
};

export default config;